import React from "react";
import {
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

export default function OptionsTable({ rows }) {
  return (
    <Box mt={6}>
      <Text fontSize="lg" fontWeight="semibold" mb={2}>
        Opzioni dei prodotti selezionati
      </Text>

      <Box overflowX="auto" width="80%">
        <Table size="sm" variant="striped" minWidth="800px">
          <Thead bg="gray.50">
            <Tr>
              <Th>Prodotto padre</Th>
              <Th>Codice Opzione</Th>
              <Th>Descrizione Opzione</Th>
              <Th isNumeric>Prezzo/mese</Th>
            </Tr>
          </Thead>

          <Tbody>
            {rows.map((opt) => (
              <Tr key={`${opt.parentCode}-${opt.product_code}`}>
                <Td>{opt.parentCode}</Td>
                <Td>{opt.product_code}</Td>
                <Td>{opt.description}</Td>
                <Td isNumeric>
                  €{opt.price_per_month.toFixed(2)}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
}
